// extracted by mini-css-extract-plugin
export var openBankingWrapperStyle = "template_open_banking_guide-module--openBankingWrapperStyle--q2dQ+";
export var outerWrapperStyle = "template_open_banking_guide-module--outerWrapperStyle--oKtJZ";